import { createEntityAdapter } from '@ngrx/entity';
import { EntityState } from '@ngrx/entity';
import * as arrearsDrillDownActions from '../actions/arrears-drilldown.actions';
import { ArrearsDrillDownParams } from '../models/arrears-drilldown-params.model';

export class ArrearsDrillDownInstance {
  id: string;
  inDrillDownMode: boolean;
  drillDownParams: ArrearsDrillDownParams;
}

export interface ArrearsDrillDownEntityState extends EntityState<ArrearsDrillDownInstance> { }

export const arrearsDrillDownEntityAdapter = createEntityAdapter<ArrearsDrillDownInstance>();

const initialState: ArrearsDrillDownEntityState = arrearsDrillDownEntityAdapter.getInitialState(
  {
    isDrillDownMode: false,
    drillDownParams: new ArrearsDrillDownParams()
  });

const entityExists = (state: ArrearsDrillDownEntityState, id: string) => (<Array<string>>state.ids).indexOf(id) !== -1;

const upsertEntity = (id: string, state: ArrearsDrillDownEntityState, instance: ArrearsDrillDownInstance | Partial<ArrearsDrillDownInstance>): ArrearsDrillDownEntityState => {
  if (entityExists(state, id)) {
    return arrearsDrillDownEntityAdapter.updateOne({
      id: id,
      changes: instance
    }, state);
  }  

  return arrearsDrillDownEntityAdapter.addOne(<ArrearsDrillDownInstance>instance, state);  

}

export function reducer(state: ArrearsDrillDownEntityState = initialState, action: arrearsDrillDownActions.Actions):
  ArrearsDrillDownEntityState {

  switch (action.type) {

    case arrearsDrillDownActions.ENTER_DRILLDOWN_MODE:
      {
        const widgetId = action.payload.widgetId.toString();
        return upsertEntity(widgetId, state, { id: widgetId, inDrillDownMode: true, drillDownParams: action.payload.drillDownParams });
      }
    case arrearsDrillDownActions.EXIT_DRILLDOWN_MODE:
      {
        const widgetId = action.payload.widgetId.toString();
        return upsertEntity(widgetId, state, { id: widgetId, inDrillDownMode: false });
      }
    default:
      {
        return state;
      }
  }
}
